const PERMISSION_KEY= "personalize:nebula_reward_transaction";
const PAGE_URL = {
    NEBULA_REWARD_TRANSACTION_PAGE: "/admin/personalize/nebula-reward-transaction"
}

export {PERMISSION_KEY, PAGE_URL}

